import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import FormTextbox from "../WindscreenClaim/components/formTextbox"
import FormFieldDisableAutoComplete from "../WindscreenClaim/components/formFieldDisableAutoComplete"
import FormDatePickerTextBox from "../WindscreenClaim/components/formDatePickerTextBox"
import FormTimeTextBox from "../WindscreenClaim/components/formTimeTextBox"
import FormDamageDesc from "../WindscreenClaim/components/formDamageDesc"
import FormAmountTextBox from "../WindscreenClaim/components/formAmountTextBox"
import FormNatureOfDamage from "../WindscreenClaim/components/formNatureOfDamage"
import { useDispatch } from "react-redux"
import {
  updateCategoryClaimData,
  updatePoliceReportMandatory,
  controlEditBenefit,
} from "../../../Redux/WindscreenClaim/actions"
import { Row, Col, Form } from "react-bootstrap"
import EditBenefitImg from "../../../content/img/editBenefit.png"
import * as Constants from "../../../common/constants"
import { isBefore, isAfter } from "date-fns"

const ParticularsOfAccident = React.memo(({ claimData, uiData }) => {
  const { pageNumber, editBenefits, clickedNext } = uiData
  const category = "claimInfo"
  const details = "policyInfo"
  const formName = "Particulars of Accident"
  const dispatch = useDispatch()

  const formClickedNext = clickedNext[formName]

  const natureOfDamage = [
    "Shattered or Broken / Cracked hit by stone while driving",
    "Shattered or Broken / Cracked hit by unknown object while driving",
    Constants.descOfDamageNeedPoliceReportUplaod,
    "Shattered or Broken Parked & found damage (Non-Vandalism)",
    "Shattered or Broken / Cracked Reversed & hit the pillar",
  ]

  const descOfDamage = uiData.descOfDamageList

  const handleNatureOfDamageChange = (category, details, value) => {
    dispatch(
      updateCategoryClaimData(category, details, "natureOfDamage", value)
    )

    if (value === Constants.descOfDamageNeedPoliceReportUplaod) {
      dispatch(updatePoliceReportMandatory(true))
    } else {
      dispatch(updatePoliceReportMandatory(false))
    }
  }

  const driverInfoSchema = Yup.object().shape({
    // Moved to first page
    // accidentDate: Yup.string()
    //   .trim()
    //   .required(Constants.accidentDateErrorMsg)
    //   .test(
    //     "accidentDate",
    //     Constants.accidentDateWithinPeriodErrorMsg,
    //     value => {
    //       return Constants.withinPeriod(
    //         claimData["claimInfo"]["claimAttributeModel"].oriStartDate,
    //         claimData["claimInfo"]["claimAttributeModel"].policyEndDate,
    //         claimData[category][details].accidentDate
    //       )
    //     }
    //   ),

    accidentTime: Yup.string()
      .trim()
      .required(Constants.accidentTimeErrorMsg)
      .matches(Constants.timepattern, Constants.accidentTimeErrorMsg)

      .test("accidentTime", Constants.futureTimeErrorMsg, value => {
        if (
          Constants.notFutureDatime(
            claimData[category][details].accidentDate,
            value
          )
        ) {
          return true
        } else {
          return false
        }
      }),
    accidentLocation: Yup.string()
      .trim()
      .required(Constants.accidentLocationErrorMsg),
    claimAmount: Yup.string()
      .trim()
      .required(Constants.claimAmountErrorMsg)
      .matches(Constants.amountpattern, Constants.claimAmountErrorMsg),
  })

  return (
    <Formik
      initialValues={claimData[category][details]}
      enableReinitialize={true}
      validationSchema={driverInfoSchema}
      validateOnMount={true}
    >
      {({ handleSubmit, isValid, handleChange }) => (
        <>
          <div
            className={
              "row form-group bigScreenNarrowing ReviewChoosedDetailDiv " +
              (pageNumber === 5 && !editBenefits[formName] ? "" : "hide")
            }
          >
            <div className="col-md-10 col-8 summaryBenefit">
              <b> {formName} </b>
            </div>
            <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
              <div className="col-12 pr-0">
                <img
                  className="editBtn"
                  src={EditBenefitImg}
                  alt=""
                  onClick={() => {
                    dispatch(controlEditBenefit(formName))
                  }}
                ></img>
              </div>
            </div>
          </div>
          <FormikForm onSubmit={handleSubmit}>
            <Row
              className={
                pageNumber === 4 || (pageNumber === 5 && editBenefits[formName])
                  ? ""
                  : "hide"
              }
            >
              <div
                className={
                  "title text-center MarginTop75 " +
                  (pageNumber === 4 ? "" : "hide")
                }
              >
                Submit online windscreen claim
              </div>
              <Row
                className={
                  "containerBody " +
                  (pageNumber === 5
                    ? "blueBG summaryContainerBody mb-4 "
                    : "marginTop3x")
                }
              >
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div
                    className={
                      "horizontal-align marginBottom1x " +
                      (pageNumber === 4 ||
                      (pageNumber === 5 && editBenefits[formName])
                        ? ""
                        : "hide")
                    }
                  >
                    <Col xs={12} md={12}>
                      <div
                        className={
                          "titleText " + (pageNumber === 5 ? "hide" : "")
                        }
                      >
                        Particulars of Accident
                      </div>
                    </Col>
                  </div>
                  {
                    <Row
                      className={
                        "form-group " + (editBenefits[formName] ? "" : "hide")
                      }
                    >
                      <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                        <p>{formName}</p>
                      </div>
                      <div className="col-md-3 col-5 marginTop10px">
                        <div
                          className="cursorPointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => dispatch(controlEditBenefit(formName))}
                        >
                          <p className="doneEdit">DONE EDIT</p>
                        </div>
                      </div>
                    </Row>
                  }
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Accident Date"
                    coverageCategory={category}
                    coverageCode={details}
                    name="accidentDate"
                    component={FormDatePickerTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    // disableBefore={
                    //   claimData["claimInfo"]["claimAttributeModel"].oriStartDate
                    // }
                    // disableAfter={
                    //   claimData["claimInfo"]["claimAttributeModel"]
                    //     .policyEndDate
                    // }
                    disabled={true} //Read only field
                  />
                  <Field
                    textDesc="Accident Time (HH:mm)"
                    coverageCategory={category}
                    coverageCode={details}
                    name="accidentTime"
                    component={FormTimeTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                  <Field
                    textDesc={"Location of Accident"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={39}
                    name="accidentLocation"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />

                  <br />

                  <Form.Group>
                    <Row>
                      <Col className="font-weight-bold">Nature Of Damage:</Col>
                    </Row>
                  </Form.Group>
                  {natureOfDamage.map((value, index) => {
                    return (
                      <Form.Group key={index}>
                        <Row>
                          <Col
                            xs={12}
                            md={12}
                            className={
                              "textforinput marginTop10px cursorPointer minHeight50px"
                            }
                            onClick={() =>
                              handleNatureOfDamageChange(
                                category,
                                details,
                                value
                              )
                            }
                          >
                            <div
                              className={
                                "FieldDescRadioButton " +
                                (claimData[category][details].natureOfDamage ===
                                value
                                  ? "tick"
                                  : "")
                              }
                            ></div>
                            <p>{value}</p>
                          </Col>
                        </Row>
                      </Form.Group>
                    )
                  })}
                  <Field
                    textDesc={Constants.natureOfDamageOther}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={500}
                    name="otherNatureOfDamage"
                    component={FormNatureOfDamage}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />
                  <br />

                  <Form.Group>
                    <Row>
                      <Col className="font-weight-bold">
                        Description of Damage:
                      </Col>
                    </Row>
                  </Form.Group>

                  {descOfDamage.map((value, index) => {
                    return (
                      <FormDamageDesc
                        key={index}
                        textDesc={value}
                        coverageCategory={category}
                        coverageCode={details}
                        claimData={claimData}
                        formIsValid={isValid}
                        formName={formName}
                        clickedNext={formClickedNext}
                      />
                    )
                  })}

                  <br />

                  <Form.Group>
                    <Row>
                      <Col className="font-weight-bold">Repair Estimate:</Col>
                    </Row>
                  </Form.Group>
                  <Field
                    textDesc="Estimated Total Repair Amount (SGD)"
                    coverageCategory={category}
                    coverageCode={details}
                    name="claimAmount"
                    component={FormAmountTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                </Col>
              </Row>
            </Row>
          </FormikForm>
        </>
      )}
    </Formik>
  )
})
export default ParticularsOfAccident
